import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, input } from "@angular/core";
import { IonicModule, ModalController, isPlatform } from "@ionic/angular";
import { AppointmentDto } from "src/app/calendar/interfaces/appointment_dto";
import { NoSelectionComponent } from 'src/app/shared/components/no-selection/no-selection.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { ModeService } from 'src/app/utils/mode.service';
import { StudentDto } from '../../interfaces/student_dto';

@Component({
    selector: 'app-exam-list',
    templateUrl: './exam-list.component.html',
    styleUrls: ['./exam-list.component.scss'],
    imports: [IonicModule, DatePipe, NoSelectionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExamListComponent implements OnInit {

  originPage = isPlatform("ios") ? "Büro" : "";
  constructor(private modalController: ModalController, public modeService: ModeService, private dialogService: DialogService) { }

  readonly exams = input<AppointmentDto[]>([]);
  readonly student = input<StudentDto>(undefined);

  ngOnInit() {
  }

  trackById() {
    return (exam) => exam.Id;
  }

  openExam(exam) {
    this.dialogService.openExamDialog(exam, this.student());
  }

  close() {
    this.modalController.dismiss();
  }

}
